import { createAsyncThunk } from '@reduxjs/toolkit';
import { LessonsService } from '../../../shared/api/model/service/lessons.service';

export const fetchLessonsAsync = createAsyncThunk('lessons/fetchLessons', async () => {
  return await LessonsService.fetchLessons();
});
